/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_Item_1_TitleInputs */

const en_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023 GRAA Top 50 Stand Alone Facility`)
};

const es_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – campo de prácticas independiente 2023`)
};

const de_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – eigenständige Übungsanlage 2023`)
};

const zh_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023 年 GRAA Top 50 独立练习场`)
};

const ar_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – منشأة تدريب مستقلة 2023`)
};

const fr_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – practice indépendant 2023`)
};

const vi_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – cơ sở tập luyện độc lập 2023`)
};

const sw_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – kituo huru cha mazoezi 2023`)
};

const th_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามฝึกอิสระติดอันดับ GRAA Top 50 ประจำปี 2023`)
};

const bs_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – samostalni objekat za vježbanje 2023`)
};

const ja_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023年 GRAA Top 50 独立型練習施設`)
};

const ko_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023 GRAA Top 50 독립형 연습 시설`)
};

const pt_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – centro de treino independente 2023`)
};

const it_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – campo pratica indipendente 2023`)
};

const sv_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – fristående träningsanläggning 2023`)
};

const nl_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – zelfstandige oefenaccommodatie 2023`)
};

const da_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – selvstændigt træningsanlæg 2023`)
};

const nb_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – frittstående treningsanlegg 2023`)
};

const fi_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – itsenäinen harjoituskeskus 2023`)
};

const pl_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – samodzielny obiekt treningowy 2023`)
};

const ru_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – отдельный тренировочный комплекс 2023`)
};

const tr_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – bağımsız antrenman tesisi 2023`)
};

const hi_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – स्वतंत्र अभ्यास सुविधा 2023`)
};

const id_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – fasilitas latihan mandiri 2023`)
};

const ms_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – kemudahan latihan bebas 2023`)
};

const cs_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – samostatné cvičné zařízení 2023`)
};

const el_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – αυτόνομη εγκατάσταση εξάσκησης 2023`)
};

const he_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – מתקן אימון עצמאי 2023`)
};

const af_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – onafhanklike oefenfasiliteit 2023`)
};

const hu_about_content_honor_2_item_1_title = /** @type {(inputs: About_Content_Honor_2_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Top 50 – önálló gyakorlópálya 2023`)
};

/**
* | output |
* | --- |
* | "2023 GRAA Top 50 Stand Alone Facility" |
*
* @param {About_Content_Honor_2_Item_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_item_1_title = /** @type {((inputs?: About_Content_Honor_2_Item_1_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_Item_1_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_item_1_title(inputs)
	if (locale === "de") return de_about_content_honor_2_item_1_title(inputs)
	if (locale === "zh") return zh_about_content_honor_2_item_1_title(inputs)
	if (locale === "ar") return ar_about_content_honor_2_item_1_title(inputs)
	if (locale === "fr") return fr_about_content_honor_2_item_1_title(inputs)
	if (locale === "vi") return vi_about_content_honor_2_item_1_title(inputs)
	if (locale === "sw") return sw_about_content_honor_2_item_1_title(inputs)
	if (locale === "th") return th_about_content_honor_2_item_1_title(inputs)
	if (locale === "bs") return bs_about_content_honor_2_item_1_title(inputs)
	if (locale === "ja") return ja_about_content_honor_2_item_1_title(inputs)
	if (locale === "ko") return ko_about_content_honor_2_item_1_title(inputs)
	if (locale === "pt") return pt_about_content_honor_2_item_1_title(inputs)
	if (locale === "it") return it_about_content_honor_2_item_1_title(inputs)
	if (locale === "sv") return sv_about_content_honor_2_item_1_title(inputs)
	if (locale === "nl") return nl_about_content_honor_2_item_1_title(inputs)
	if (locale === "da") return da_about_content_honor_2_item_1_title(inputs)
	if (locale === "nb") return nb_about_content_honor_2_item_1_title(inputs)
	if (locale === "fi") return fi_about_content_honor_2_item_1_title(inputs)
	if (locale === "pl") return pl_about_content_honor_2_item_1_title(inputs)
	if (locale === "ru") return ru_about_content_honor_2_item_1_title(inputs)
	if (locale === "tr") return tr_about_content_honor_2_item_1_title(inputs)
	if (locale === "hi") return hi_about_content_honor_2_item_1_title(inputs)
	if (locale === "id") return id_about_content_honor_2_item_1_title(inputs)
	if (locale === "ms") return ms_about_content_honor_2_item_1_title(inputs)
	if (locale === "cs") return cs_about_content_honor_2_item_1_title(inputs)
	if (locale === "el") return el_about_content_honor_2_item_1_title(inputs)
	if (locale === "he") return he_about_content_honor_2_item_1_title(inputs)
	if (locale === "af") return af_about_content_honor_2_item_1_title(inputs)
	if (locale === "hu") return hu_about_content_honor_2_item_1_title(inputs)
	return en_about_content_honor_2_item_1_title(inputs)
});